export * from './file-image/file-image.component';
export * from './loader/loader.component';
export * from './confirmation-dialog/confirmation-dialog.component';
